export default "/react/directIcon-c95e0d94.svg";